<template>
  <div class="column full-height">
    <header
      class="row q-pl-2x-md q-pt-2x-md full-width no-wrap"
      :style="{ height: '60px' }"
    >
      <span class="text-md text-neutral text-weight-medium">Activities</span>
    </header>
    <q-separator color="neutral-40 q-mx-xl" />
    <div class="q-px-2x-md q-py-xl col">
      <div class="row items-center justify-end">
        <span>Filter By Duration</span>
        <PSelect
          v-model="selectedFilter"
          class="q-ml-sm flex items-center"
          placeholder="Filter by"
          option-label="label"
          option-value="value"
          :options="filterOptions"
        />
      </div>
      <div
        v-if="initialLoading"
        class="flex items-center justify-center full-height"
      >
        <q-spinner color="primary" size="40px" />
      </div>
      <PTimeline v-else>
        <div v-if="!logTrail?.length">No activity yet!</div>
        <PTimelineEntry v-for="(timeline, index) in logTrail" :key="index">
          <template #default>
            <div class="text-weight-regular text-sm">
              {{ timeline.description || "-" }}
            </div>
            <div class="text-weight-regular text-xs text-neutral-70">
              {{ formatDate(timeline.event_time, "DD MMM YYYY, h:mm a") }}
            </div>
          </template>
        </PTimelineEntry>
      </PTimeline>
      <PLoadingCta
        :loading="loadMoreLoading"
        :has-more="hasMore"
        @load-more="loadMore"
      />
    </div>
  </div>
</template>

<script setup>
import { date } from "quasar";
import { getStartEndDateBy } from "src/assets/scripts/utilities/helpers";

const { formatDate } = date;

const { user } = storeToRefs(useUserStore());
const { logTrail } = storeToRefs(useAuditLogsStore());

const selectedFilter = ref("");

const filterOptions = ref([
  { label: "All", value: "" },
  { label: "This Week", value: "week" },
  { label: "This Month", value: "month" },
  { label: "This Year", value: "year" },
]);

const params = computed(() => {
  const baseParams = {
    entity: "User",
    entity_id: unref(user)._id,
  };

  const selectedRange = getStartEndDateBy({ by: selectedFilter.value });

  if (selectedRange) {
    return {
      ...baseParams,
      event_time_gte: formatDate(selectedRange.gte, "YYYY-MM-DD"),
      event_time_lte: formatDate(selectedRange.lte, "YYYY-MM-DD"),
    };
  }

  return baseParams;
});

const { initialLoading, loadMoreLoading, hasMore, loadMore } =
  useAuditLogsPagination(params);
</script>
